import { type MatrixValueGroup } from '../../../v1';
import { Entity, type EntityProps } from '../entity';
import { UUID } from '../uuid/entity';

export interface MatrixValueProps extends EntityProps {
    name: string;
    color: string;
    group: MatrixValueGroup;
    description?: string;
}

export class MatrixValue extends Entity {
    color: string;
    group: MatrixValueGroup;
    name: string;
    description?: string;

    constructor({ id, name, color, group, description }: MatrixValueProps) {
        super({ id });
        this.name = name;
        this.group = group;
        this.color = color;
        this.description = description;
    }

    static new(props: Omit<MatrixValueProps, 'id'>): MatrixValue {
        return new MatrixValue({
            id: new UUID().toString(),
            ...props,
        });
    }
}
